import { simple_api_request } from './simple_api_request'
import { get } from './core'

/**
 * Async get wishlist
 * @param {string} token
 * @return {Promise<boolean>}
 */
export function wishlist__get (token) {
  return get('/api/wishlist', token)
}

/**
 * Async wishlist__attach_experience
 * @param {string} experience_id
 * @param {string} token
 * @return {Promise<boolean>}
 */
export function wishlist__attach_experience (experience_id, token) {
  return simple_api_request({
    path: '/api/wishlist/experiences/attach/',
    data: {experience_id},
    header_token: token
  })
}

/**
 * Async wishlist__detach_experience
 * @param {string} experience_id
 * @param {string} token
 * @return {Promise<boolean>}
 */
export function wishlist__detach_experience (experience_id, token) {
  return simple_api_request({
    path: '/api/wishlist/experiences/detach/',
    method: 'DELETE',
    data: {experience_id},
    header_token: token
  })
}


// WEBPACK FOOTER //
// ./src/api/wishlist.js